export enum AuthProviders {
    patient = "OKTA_PATIENT",
    accessCode = "PROVIDED_ACCESS_CODE",
}
